import type { SheetArcGeometry, SheetPolylineGeometry } from "building-types/views/sheetGeometryTypes";
import { sheetPolylineGeometryNew } from "building-types/views/sheetGeometryTypes";
import { ellipticalArc2ByCenterStartEnd } from "geom/arc";
import { polyLine2New } from "geom/polyLine2Types";

export function arcToPolyLine(arc: SheetArcGeometry): SheetPolylineGeometry {
  // we need to strip the type from the arc since the spread operator will break the polylineGeometry
  // by inserting an ARC type
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { x, y, xRadius, yRadius, startRad, endRad, clockwise, type: _type, ...arcProps } = arc;
  const arcPoints = ellipticalArc2ByCenterStartEnd(x, y, xRadius, yRadius ?? xRadius, startRad, endRad, !!clockwise);
  if (arc.fill || arc.fillColor) {
    arcPoints.unshift([x, y]);
    arcPoints.push([x, y]);
  }
  return sheetPolylineGeometryNew({
    paths: [polyLine2New(arcPoints.flat())],
    ...arcProps,
  });
}
